import React from 'react';
import { Popup } from '@leverege/ui-elements';
import { GroupDataViewers, ItemInfoDataViewers } from "../../DataViewers.js";
import AbstractGroupScreen from "../../../screens/group/AbstractGroupScreen.js";
import AbstractItemInfoScreen from "../../../screens/itemInfo/AbstractItemInfoScreen.js";
import ViewerSelector from "../ViewerSelector.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default {
  id: 'molten.dataViewers.layout.layoutAction',
  matches: {
    use: ['layoutActionBar', 'headerOptions']
  },
  handles: context => true,
  layout: {
    sort: 'c'
  },
  customComponent: ({
    context
  }) => {
    const cxt = context.mobile ? context?.clientState?.actionsContext || {} : context;
    const {
      client,
      clientProps: {
        clientType,
        relationship,
        settings,
        settingsPath
      } = {},
      getDataViewerProps,
      onViewerChange,
      layout,
      mobile
    } = cxt;
    let dataViewers;
    if (client === AbstractGroupScreen.CLIENT) {
      dataViewers = GroupDataViewers;
    } else if (client === AbstractItemInfoScreen.CLIENT) {
      dataViewers = ItemInfoDataViewers;
    } else {
      return null;
    }
    const showLayout = ViewerSelector.allowEditing(cxt);
    if (showLayout) {
      const currLayout = layout.modifiedLayout || settings || {};
      return /*#__PURE__*/_jsx(Popup, {
        toggleVariant: mobile ? 'mobileActionBar' : 'actionBar',
        toggleAttributes: {
          iconOn: ViewerSelector.getLayoutIcon(),
          iconOff: ViewerSelector.getLayoutIcon()
        },
        children: /*#__PURE__*/_jsx(ViewerSelector.Popup, {
          parentClient: clientType,
          settingsPath: settingsPath,
          settingsProps: getDataViewerProps,
          dataViewers: dataViewers,
          onChange: onViewerChange,
          value: currLayout,
          relationship: relationship,
          context: cxt
        })
      });
    }
    return null;
  }
};